export function MascaraCnh(value) {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    if (value.length > 11) value = value.slice(0, 11);

    return value;
}